// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__1KvQZ"};